import React from 'react';
import HeadlineWithFocus from "../../components/HeadlineWithFocus";
import styled from 'styled-components';
import { Page, Row, Column } from 'hedron';
import ColorBar from '../../components/colorbar';
import logoTEXT from '../../assets/images/apps/DBDwall/logo.png';
import logoIMG from '../../assets/images/apps/DBDwall/DBDwall.png';
import inprogress from '../../assets/images/apps/inprogress.png';
import Form from '../../components/contact/index.en';
import DownloadIcon from '../../assets/images/apps/ask.png';
import ScrollableAnchor from 'react-scrollable-anchor';



const ImageWrapper = styled.div.attrs({

  image: props => props.image
})`
  background-image: url(${props => props.image});
  background-size: 100%;
  @media (min-width: 300px) {
    background-position: center;
    background-repeat: no-repeat;
    height: 450px;
  }
`

const DownloadIconContainer = styled.div`
	position: fixed;
	zIndex: 999;
	background-image: url(${DownloadIcon});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
  @media (max-width: 299px) {
    right: 10%;
    bottom: 0%;
    width: 20%;
    height: 20%;
  }
  @media (min-width: 300px) {
    right: 10%;
    bottom: 0%;
    width: 15%;
    height: 15%;
  }
  @media (min-width: 600px) {
    right: 7%;
    bottom: 2%;
    width: 12%;
    height: 12%;
  }
  @media (min-width: 1100px) {
    right: 2%;
	  bottom: 2%;
	  width: 15%;
	  height: 15%;
	}

`

const ImgColStyle = {
  padding: '0',
};


const RowStyleEVEN = {
  background: '#F9F9F9',
};

const RowStyleODD = {
  background: '#F5F5F5',
};


const About = props => {
    return (
		<div>
			<a href="#download">
				<DownloadIconContainer />
			</a>
			<Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={logoTEXT} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '10px solid #DFAB50'}}>DBD Pier</u></h1>
				  <h3><p>Displacement-Based design for Single Degree of Freedom Systems, with particular reference to bridge piers. For a given target drift, this app provides the detailing of a circular bridge pier to comply with a given seismic demand</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
        <Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
           <ImageWrapper image={logoIMG} />
        </Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Completely standalone</u><br />
                    </h1>
				  <h3><p>
				  	You don’t need any other software to run it
				  </p></h3>
				</Column>
			</Row>

			<Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={inprogress} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Work in progress</u></h1>
				  <h3><p>This app is under development</p></h3>
				</Column>
			</Row>

      <Row>
				<ScrollableAnchor id={'download'}>
                	<Column xs={12} sm={12} smShift={0} md={10} mdShift={1} lg={8} lgShift={2}>
                		<Form formname="dbdpier"/>
					</Column>
				</ScrollableAnchor>
      </Row>
		</div>
	)
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/dbd_p/index.en.jsx